module.exports = __webpack_public_path__ + "static/media/400045_02.d6e3d24d.png";